module.exports = __webpack_public_path__ + "static/media/icon_note.d2b4ae9a.svg";